<script lang="ts">
  import { page } from '$app/state'

  let seo = $derived(page.data.seo ?? {})

  let title = $derived(
    seo.fullyReplaceTitle
      ? seo.title
      : `Pausly${seo.title ? ` | ${seo.title}` : ''}`,
  )

  let description = $derived(
    seo.description ??
      'Take a short break from your work to stretch, get stronger and chat with your colleagues and friends.',
  )

  let url = $derived(seo.url ?? `https://www.pausly.app`)

  let ogTitle = $derived(seo.ogTitle ?? title)

  let og = $derived(seo.og ?? true)
</script>

<svelte:head>
  <title>{title}</title>
  <meta name="description" content={description} />
  <meta
    name="keywords"
    content="pausly, stretch, take a break, pause, timer, team workout, yoga, five minute pause"
  />

  {#if og}
    <meta property="og:site_name" content="Pausly" />
    {#if ogTitle}
      <meta property="og:title" content={ogTitle} />
    {/if}
    <meta property="og:url" content={url} />
    <meta property="og:description" content={description} />
  {/if}

  {#if seo.image}
    <meta property="og:image" content={seo.image.url} />
    {#if seo.image.type}
      <meta property="og:image:type" content={seo.image.type} />
    {/if}
    <meta property="og:image:width" content={`${seo.image.width}`} />
    <meta property="og:image:height" content={`${seo.image.height}`} />
  {/if}
</svelte:head>
